import React, { useEffect } from 'react';
import { generateNavURL } from '../../../utils/generateNavURL';

const PrimaryNavDesktop = ({ portalUri, apiNavigationTop }) => {
    const menuLinks = apiNavigationTop?.data ?? [];
    const generateURL = (url) => generateNavURL(url, portalUri);

    useEffect(() => {
        const script = document.createElement('script');
      
        script.src = '/assets/js/2018/submenu.js';  // Ensures that menu + submenu will expand and collapse
        script.async = true;
      
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        }
      }, [apiNavigationTop]);


    return (
        <>
            {menuLinks.map((navigation, levelOneKey) => (
                <React.Fragment key={`top-nav-item-${levelOneKey}`}>
                    {navigation?.children?.length ? (
                        <div className='nav-primary-link has-subnav' id='nav-primary-play-online'  >
                            <button className='nav-primary-link-inner' aria-haspopup={true}>
                                {navigation?.name}{' '}
                                <i className='fa fa-caret-down' role='img' aria-hidden='true' aria-label='Caret pointing down to signify expandable content'>
                                    &nbsp;
                                </i>
                            </button>
                            <div className='nav-primary-more' role='menu'>
                                {navigation?.children?.map((submenuL1, levelTwoKey) => (
                                    <React.Fragment key={`top-nav-item-${levelOneKey}-${levelTwoKey}`}>
                                        {submenuL1?.children?.length ? (
                                            <div className='has-subnav' id='nav-secondary-promotions'>
                                                <button
                                                    className='btn-nav-secondary subnav-parent'
                                                    aria-haspopup='true'
                                                    aria-expanded='false'>
                                                    {submenuL1?.name}{' '}
                                                    <i
                                                        className='fa fa-caret-down'
                                                        role='img'
                                                        aria-hidden='true'
                                                        aria-label='Caret pointing down to signify expandable content'>
                                                        &nbsp;
                                                    </i>
                                                </button>
                                                <div className='nav-secondary-more' role='menu'>
                                                    {submenuL1?.children?.map((submenuL2, levelThreeKey) => (
                                                        <a
                                                            className='nav-secondary-more-item'
                                                            key={`top-nav-item-${levelOneKey}-${levelTwoKey}-${levelThreeKey}`}
                                                            href={generateURL(submenuL2?.get_url)}
                                                            role='menuitem'
                                                            tabIndex='-1'>
                                                            {submenuL2?.name}{' '}
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <a href={generateURL(submenuL1?.get_url)} role='menuitem' tabIndex='-1'>
                                                {submenuL1?.name}
                                            </a>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    ) : (
                            <a className='nav-primary-link' href={generateURL(navigation?.get_url)} {...(navigation?.open_new ? `target="_blank"` : ``)}>
                                {navigation?.name}
                            </a>
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

export default PrimaryNavDesktop;
